import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Next, NextDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getNext(): Observable<Next> {
        return this.httpClient.get<NextDto | null>('api/v1/content/next').pipe(map((dto) => new Next(dto)));
    }
}
